import {
  createFileRoute,
  Outlet,
  retainSearchParams,
} from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { CollectionStateProvider } from "@/features/Generations/context/CollectionStateContext";
import {
  collectionFlowSearchSchema,
  searchKeys,
} from "@/features/Generations/flowSearch";

export const Route = createFileRoute(
  "/_auth/generations/$siteId/new/collection",
)({
  component: RouteComponent,
  validateSearch: zodValidator(collectionFlowSearchSchema),
  search: {
    middlewares: [retainSearchParams(searchKeys(collectionFlowSearchSchema))],
  },
});

function RouteComponent() {
  const { propagationId } = Route.useSearch();

  return (
    <CollectionStateProvider initialState={{ propagationSlug: propagationId }}>
      <Outlet />
    </CollectionStateProvider>
  );
}
